import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TopBar from '../components/TopBar';
import WorkerIcons from '../components/WorkerIcons';
import NftList from '../components/NftList';
import CenterPanel from '../components/CenterPanel';
import { 
  getplayerTable,
  getplayerToolsWithDecayData,
  getplayerWorkersWithDecayData,
  getTokenBalance, 
  actRegister, 
  getConfigs ,
  getUserHealerData
} from '../api/waxApi';
import './GameView.css';
import { logout } from '../api/waxApi';
import ActionModal from '../components/ActionModal';
import ErrorModal from '../components/ErrorModal';
import LoadingModal from '../components/LoadingModal';
import EnergyModal from '../components/EnergyModal';
import RepairInfoModal from '../components/RepairInfoModal';
import { useLocation } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';
import NotificationModal from '../components/NotificationModal';


function GameView() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const referrer = searchParams.get('ref') || '';

  const navigate = useNavigate();
  const { wallet } = useParams(); // Bu sayfa URL'sinden gelir (görüntülenen cüzdan)
  const loggedInUser = localStorage.getItem('loggedInUser'); // Bu giriş yapan kullanıcı
  const [selectedNft, setSelectedNft] = useState(null);
  const [userNfts, setUserNfts] = useState([]);
  const [userInventory, setUserInventory] = useState([]);
  const [userWorkers, setuserWorkers] = useState([]);
  const [playerHealData, setPlayerHealData] = useState([]);
  const [balances, setBalances] = useState([]);
  const [tokenBalances, setTokenBalances] = useState([]);
  const [assistance, setAssistance] = useState("");
  const [stamina, setStamina] = useState({ first: 200, second: 500 });
  const [notFound, setNotFound] = useState(false);
  const [tab, setTab] = useState('home');
  const [logModalOpen, setLogModalOpen] = useState(false);
  const [logLines, setLogLines] = useState([]);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingVisible, setLoadingVisible] = useState(false);
  const [search, setSearch] = useState('');
  const [isSearchValid, setIsSearchValid] = useState(false);
  const [walletVisible, setWalletVisible] = useState(true);
  const [searchRaw, setSearchRaw] = useState('');
  const [energyModalOpen, setEnergyModalOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [seasonId, setSeasonId] = useState(null);
  const [repairModalOpen, setRepairModalOpen] = useState(false);
  const [repairSelectedNFT, setRepairSelectedNFT] = useState(null);
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);

  // Use notification context
  const { 
    hasUnreadNotifications, 
    markNotificationsAsViewed, 
  } = useNotifications();


  const isValidEosioName = (name) => /^[a-z1-5.]{1,12}$/.test(name);

  const handleNotificationClick = () => {
    setNotificationModalOpen(true);
    markNotificationsAsViewed();
  };

  useEffect(() => {
    // Kullanıcı login olmamışsa, doğrudan login sayfasına yönlendir
    if (!loggedInUser) {
      navigate('/play');
      return;
    }

    // Geri kalan işlemleri çalıştır
    const load = async () => {
      // ... zaten var olan load fonksiyonun
    };

    if (wallet) load();
  }, [wallet, loggedInUser, navigate]);


  useEffect(() => {
    const load = async () => {
      try {
        setLoadingProgress(0);
        setLoadingVisible(true);

        await delay(200);
        setLoadingProgress(5);
        const configs = await getConfigs();
        if (configs?.session) setSeasonId(configs.session);

        setLoadingProgress(10);
        const data = await getplayerTable(wallet);
        if (!data) {
          if (wallet === loggedInUser) {
            setShowRegisterModal(true);
          } else {
            setNotFound(true);
          }
          setLoadingVisible(false);
          return;
        }

        if (referrer && wallet === loggedInUser) {
          navigate(`/play/${wallet}`, { replace: true });
        }

        setNotFound(false); // ✅ buraya koy

        setLoadingProgress(20);
        setBalances(Array.isArray(data.balances) ? data.balances : Object.values(data.balances));
        setStamina(data.stamina);
        setAssistance(data.assistant_account || "");

        setLoadingProgress(30);
        
        const nftList = await getplayerToolsWithDecayData(data.staked_nft, wallet);
        setUserNfts(nftList);
        setLoadingProgress(70);
        const workerList = await getplayerWorkersWithDecayData(data.staked_workers, wallet);
        setuserWorkers(workerList);
        setLoadingProgress(80);
        
        // Fetch player heal data
        const healData = await getUserHealerData(wallet);
        console.log(`🏥 Loaded heal data for ${wallet}:`, healData);
        setPlayerHealData(healData || []);

        setLoadingProgress(90);

        const tokenSymbols = ["RANCH", "FARM", "TOOL", "RCOIN"];
        const walletToken = await Promise.all(
          tokenSymbols.map(symbol => getTokenBalance("ranchersbank", wallet, symbol))
        );
        setTokenBalances(walletToken);

        setUserInventory([]);
        setLoadingProgress(100);
        setTimeout(() => setLoadingVisible(false), 300);

      } catch (err) {
        console.error("load error:", err);
        setNotFound(true);
        setLoadingVisible(false);
      }
    };

    if (wallet) load();
  }, [wallet, loggedInUser]);

  useEffect(() => {
    if (wallet === loggedInUser) {
      setSearch('');
      setSearchRaw('');
    } else {
      setSearch(wallet);
      setSearchRaw(wallet);
    }
  }, [wallet, loggedInUser]);

  const handleLogout = async () => {
    logout()
    navigate(`/play${referrer ? `?ref=${referrer}` : ''}`);
  };

  const handleRegister = async () => {
    if (isProcessing) return;
    setIsProcessing(true);
    const tx = await actRegister(referrer);

    if (tx?.error) {
      setErrorMessage(tx.error);
      setErrorModalOpen(true);
      return;
    }

    if (tx?.log) {
      setLogLines(Array.isArray(tx.log) ? tx.log : [tx.log]);
      setLogModalOpen(true);
    }
    await refreshData();
    setShowRegisterModal(false);
  };

  const delay = (ms) => new Promise(res => setTimeout(res, ms));

  const refreshData = async () => {
    try {
      setIsProcessing(false);
      setLoadingProgress(0);
      setLoadingVisible(true);

      await delay(500);
      setLoadingProgress(5);
      
      const configs = await getConfigs();
      if (configs?.session) setSeasonId(configs.session);
      setLoadingProgress(10);

      const data = await getplayerTable(wallet);
      if (!data) {
        if (wallet === loggedInUser) {
          setShowRegisterModal(true);
        } else {
          setNotFound(true);
        }
        setLoadingVisible(false);
        return;
      }

      setLoadingProgress(20);
      // Token and stamina data
      const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
      const stamina = { ...data.stamina };
      const assistance = data.assistant_account || "";
      setLoadingProgress(30);

      // Fetch all NFTs at once (more efficient than individual calls)
      const nftList = await getplayerToolsWithDecayData(data.staked_nft, wallet);
      console.log(`🔄 Refreshed ${nftList.length} NFTs with decay data`);

      setLoadingProgress(70);
      
      // Fetch all workers at once (more efficient than individual calls)
      const workerList = await getplayerWorkersWithDecayData(data.staked_workers, wallet);
      console.log(`🔄 Refreshed ${workerList.length} workers with decay data`);

      setLoadingProgress(75);
      
      // Fetch player heal data
      const healData = await getUserHealerData(wallet);
      console.log(`🔄 Refreshed heal data for ${wallet}:`, healData);

      setLoadingProgress(80);
      
      // Token balances (RANCH, FARM, TOOL, RCOIN)
      const tokenSymbols = ["RANCH", "FARM", "TOOL", "RCOIN"];
      const tokenBalances = await Promise.all(
        tokenSymbols.map(symbol => getTokenBalance("ranchersbank", wallet, symbol))
      );

      setLoadingProgress(100);
      setTimeout(() => setLoadingVisible(false), 300);
      
      // Update all state with new references to trigger re-renders
      setBalances([...balances]);
      setStamina({ ...stamina });
      setAssistance(assistance);
      setUserNfts([...nftList]);
      setuserWorkers([...workerList]);
      setPlayerHealData(healData || []);
      setTokenBalances([...tokenBalances]);

    } catch (err) {
      console.error("refreshData error:", err);
      setNotFound(true);
      setLoadingVisible(false);
    }
  };


  const refreshNFT = async (asset_id) => {
    setIsProcessing(false);
    
    try {
      await delay(500);
      const [nftResult, data] = await Promise.all([
        getplayerToolsWithDecayData([asset_id], wallet),
        getplayerTable(wallet)
      ]);

      // Get the first (and only) NFT from the array result
      const updatedNft = nftResult?.[0];
      
      if (updatedNft) {
        setUserNfts(prev =>
          prev.map(n =>
            n.asset_id === asset_id ? updatedNft : n
          )
        );
        console.log(`🔄 Refreshed NFT ${asset_id}:`, updatedNft);
      }

      const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
      const stamina = { ...data.stamina };

      setBalances([...balances]);
      setStamina({ ...stamina });
    } catch (error) {
      console.error('Error refreshing NFT:', error);
    }
  };

  const refreshWorker = async (asset_id) => {
    setIsProcessing(false);
    try {
      await delay(500);
      const [workerResult, data] = await Promise.all([
        getplayerWorkersWithDecayData([asset_id], wallet),
        getplayerTable(wallet)
      ]);

      // Get the first (and only) worker from the array result
      const updatedWorker = workerResult?.[0];
      
      if (updatedWorker) {
        setuserWorkers(prev =>
          prev.map(w =>
            w.asset_id === asset_id ? updatedWorker : w
          )
        );
      }

      const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
      const stamina = { ...data.stamina };

      setBalances([...balances]);
      setStamina({ ...stamina });
    } catch (error) {
      console.error('Error refreshing worker:', error);
    }
  };

  const refreshStamina = async () => {
    setIsProcessing(false);
    const data = await getplayerTable(wallet);
    if (!data) return;

    const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
    const stamina = { ...data.stamina };

    setBalances([...balances]);
    setStamina({ ...stamina });
  };

  const refreshFinance = async () => {
    setIsProcessing(false);
    
    try {
      const data = await getplayerTable(wallet);
      if (!data) {
        console.error('No player data returned in refreshFinance');
        return;
      }

      // Oyun içi balances ve stamina
      const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
      const stamina = { ...data.stamina };

      // Tokenlar (RANCH, FARM, TOOL, RCOIN)
      const tokenSymbols = ["RANCH", "FARM", "TOOL", "RCOIN"];
      const tokenBalances = await Promise.all(
        tokenSymbols.map(symbol => getTokenBalance("ranchersbank", wallet, symbol))
      );

      console.log('RefreshFinance - Updated token balances:', tokenBalances);
      
      setBalances([...balances]);
      setStamina({ ...stamina });
      setTokenBalances([...tokenBalances]);
    } catch (error) {
      console.error('Error in refreshFinance:', error);
    }
  };

  const refreshUser = async () => {
    setIsProcessing(false);
    const data = await getplayerTable(wallet);
    if (!data) return;

    const balances = Array.isArray(data.balances) ? data.balances : Object.values(data.balances);
    const stamina = { ...data.stamina };

    setBalances([...balances]);
    setStamina({ ...stamina });
  };

  const refreshHealData = async () => {
    setIsProcessing(false);
    try {
      const healData = await getUserHealerData(wallet);
      console.log(`🔄 Refreshed heal data for ${wallet}:`, healData);
      setPlayerHealData(healData || []);
    } catch (error) {
      console.error('Error refreshing heal data:', error);
    }
  };

  const getTimeOfDay = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 9) return "morning";
    if (hour >= 9 && hour < 18) return "day";
    if (hour >= 18 && hour < 20) return "evening";
    return "night";
  };

  const [timeOfDay, setTimeOfDay] = useState(getTimeOfDay());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay());
    }, 1000 * 60 * 5); // 5 dakikada bir güncelle
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkOrientation = () => {
      const warning = document.getElementById('rotate-warning');
      const isLandscape = window.matchMedia("(orientation: landscape)").matches;

      warning.style.display = isLandscape ? 'none' : 'flex';
    };

    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);
    checkOrientation();

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);


  return (
    <div className="game-container">

      {showRegisterModal && (
        <div className="register-modal">
          <div className="register-modal-blur" />
          <div className="register-modal-panel">
            <div className="register-modal-text">
              {wallet} ~ No user data found.<br />
              Would you like to register?
            </div>
            <button
              className="register-modal-button"
              onClick={handleRegister}
              disabled={isProcessing}
            >
              {isProcessing ? "Waiting" : "Register"}
            </button>
          </div>
        </div>
      )}

      {notFound && (
        <div className="not-found-overlay">
          <div className="overlay-blur" />
          <div className="overlay-content">
            {wallet} ~ User not found!<br />
            <button
              className="back-button"
              onClick={() => navigate('/play')}
            >
              Back
            </button>
          </div>
        </div>
      )}

      <div className="top-right-user-info">
        <span
          className="wallet-visibility-toggle"
          onClick={() => setWalletVisible(prev => !prev)}
          title={walletVisible ? "Hide Wallet & Input" : "Show Wallet & Input"}
        >
          {walletVisible ? "👁️" : "🙈"}
        </span>

        <span
          className="wallet-link"
          onClick={() => {
            setSearchRaw('');
            setSearch('');
            navigate(`/play/${loggedInUser}`);
          }}
        >
          {walletVisible ? loggedInUser : '************'}
        </span>

        <button className="logout-button" onClick={handleLogout}>
          Logout
        </button>
      </div>

      <div className="wallet-search-box">
        <span
          className={`wallet-visibility-toggle ${searchRaw ? '' : 'disabled'}`}
          onClick={() => {
            if (searchRaw) setWalletVisible(prev => !prev);
          }}
          title={walletVisible ? "Hide Wallet & Input" : "Show Wallet & Input"}
        >
          {walletVisible ? "👁️" : "🙈"}
        </span>

        <input
          type={walletVisible ? 'text' : 'password'}
          maxLength="12"
          placeholder=""
          value={searchRaw}
          onChange={(e) => {
            const raw = e.target.value;
            const filtered = raw
              .toLowerCase()
              .replace(/[^a-z1-5.]/g, '')
              .slice(0, 12);

            setSearchRaw(filtered);
            setSearch(filtered);
            setIsSearchValid(isValidEosioName(filtered));
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isSearchValid) {
              navigate(`/play/${search}`);
            }
          }}
        />

        <button
          className="wallet-search-button"
          disabled={!searchRaw || !isSearchValid || search === wallet}
          onClick={() => navigate(`/play/${search}`)}
        >
          GO
        </button>
      </div>

      <TopBar
        balances={balances}
        stamina={stamina}
        wallet={wallet}
        onRefresh={refreshData}
        setLogLines={setLogLines}
        setLogModalOpen={setLogModalOpen}
        setErrorModalOpen={setErrorModalOpen}
        setErrorMessage={setErrorMessage}
        onOpenEnergyModal={() => setEnergyModalOpen(true)}
        seasonId={seasonId}
      />
      <WorkerIcons
        stakedWorkers={userWorkers}
        onSelect={setSelectedNft}
        currentTab={tab}
        setTab={setTab}
      />

      <div className={`game-background ${timeOfDay}`}>
        <div className="game-content">
          <CenterPanel
            selected={selectedNft}
            nfts={userNfts}
            workers={userWorkers}
            playerHealData={playerHealData}
            tab={tab}
            setTab={setTab}
            balances={balances}
            tokenBalances={tokenBalances}
            setTokenBalances={setTokenBalances}
            inventory={userInventory}
            setUserInventory={setUserInventory}
            wallet={wallet}
            onRefresh={refreshData}
            refreshNFT={refreshNFT}
            refreshWorker={refreshWorker}
            refreshFinance={refreshFinance}
            refreshUser={refreshUser}
            refreshHealData={refreshHealData}
            setLogLines={setLogLines}
            setLogModalOpen={setLogModalOpen}
            assistance={assistance}
            setErrorModalOpen={setErrorModalOpen}
            setErrorMessage={setErrorMessage}
            stamina={stamina}
            isProcessing={isProcessing}
            setIsProcessing={setIsProcessing}
            seasonId={seasonId}
            onOpenRepairModal={(nft) => {
              setRepairSelectedNFT(nft);
              setRepairModalOpen(true);
            }}
            notificationModalOpen={notificationModalOpen}
            setNotificationModalOpen={setNotificationModalOpen}
          />
          <NftList nfts={userNfts} onSelect={setSelectedNft} currentTab={tab} setTab={setTab} />
        </div>
      </div>

      <div id="rotate-warning">
        <div className={`rotate-warning-blur ${timeOfDay}`}></div>
        <div className="rotate-warning-content">
          Please rotate your device to landscape mode for a better experience.
        </div>
      </div>
      <ActionModal open={logModalOpen} onClose={() => setLogModalOpen(false)} logLines={logLines} />
      <ErrorModal
        open={errorModalOpen}
        onClose={() => {
          setErrorModalOpen(false);
          refreshData();
        }}
        message={errorMessage}
      />
      {energyModalOpen && (
        <EnergyModal
          onClose={() => setEnergyModalOpen(false)}
          wallet={wallet}
          refreshStamina={refreshStamina}
          setLogLines={setLogLines}
          setLogModalOpen={setLogModalOpen}
          setErrorModalOpen={setErrorModalOpen}
          setErrorMessage={setErrorMessage}
          balances={balances}
          stamina={stamina}
          seasonId={seasonId}
        />
      )}
      <RepairInfoModal
        open={repairModalOpen}
        onClose={() => setRepairModalOpen(false)}
        selectedNFT={repairSelectedNFT}
        seasonId={seasonId}
      />
      
      <NotificationModal 
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
      />
      
      {loadingVisible && <LoadingModal progress={loadingProgress} />}
    </div>
  );
}

export default GameView;
